module.exports = __webpack_public_path__ + "img/user-1.0304cf83.png";